import { useEffect, useRef } from 'react';

const EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];

export const useIdleTimer = (
    onIdle: () => void,
    timeout: number,
    isActive: boolean
) => {
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const lastActivityRef = useRef<number>(Date.now());

    useEffect(() => {
        if (!isActive) return;

        const startTimer = () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                onIdle();
            }, timeout);
        };

        const handleActivity = () => {
            const now = Date.now();
            if (now - lastActivityRef.current > 500) {
                lastActivityRef.current = now;
                startTimer();
            }
        };

        startTimer();

        EVENTS.forEach(event => {
            window.addEventListener(event, handleActivity);
        });

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            EVENTS.forEach(event => {
                window.removeEventListener(event, handleActivity);
            });
        };
    }, [onIdle, timeout, isActive]);
};